import {getData} from './redux_data';
import {
    GET_CAJAS_CENTRO, ADD_CAJA_CENTRO, MODIFY_CAJA_CENTRO, REMOVE_CAJA_CENTRO //cajas de un centro
} from '../constants/action_types';


export function getCajasCentro(centroId) {
    // return getData('cajas/vcajas/' + centroId, GET_CAJAS_CENTRO);
    return getData('vcajas?centro_id=' + centroId, GET_CAJAS_CENTRO);
}

export function modifyCajaCentro(caja) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_CAJA_CENTRO, payload: caja });
    }
}

export function addCajaCentro(caja) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CAJA_CENTRO, payload: caja });
    }
}

export function removeCajaCentro(caja) {
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_CAJA_CENTRO, payload: caja });
    }
}